<template>
  <div id="promotions">
    <div>
      <v-row>
        <v-col cols="12" md="4" lg="12" class="text-left">
          <h3 class="display-1 font-weight-thin">
            {{ $t('Promotions') }}
          </h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3" md="4" class="text-center">
          <v-card color="primary">
            <div class="mt-5">
              <v-avatar size="60">
                <v-icon large>
                  mdi-link
                </v-icon>
              </v-avatar>
            </div>
            <v-card-title class="d-block">
              {{ $t('Affiliate program') }}
            </v-card-title>

            <v-card-text>
              <p>
                {{ $t('Refer your friends to the casino and get bonuses when they play games.') }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import {config} from '~/plugins/config'

export default {
  computed: {
    paymentsPackageEnabled() {
      return this.$store.getters['package-manager/get']('payments')
    }
  },

  methods: {
    config
  }
}
</script>

<style>

</style>
